module.exports = __webpack_public_path__ + "static/media/logoimage75.9406ab42.png";